import React, { useContext, useState } from "react";

// Services
import sessionStorage from "../services/storage/SessionStorage";

const UserInfoContext = React.createContext(null);
const UpdateUserInfoContext = React.createContext(() => {});

export const useUserInfo = () => {
	return useContext(UserInfoContext);
};

export const useUserInfoUpdate = () => {
	return useContext(UpdateUserInfoContext);
};

export function UserInfoProvider({ children }) {
	const authObj = sessionStorage.getPathName("authObj");
	const [userInfo, setUserInfo] = useState(authObj);

	return (
		<UserInfoContext.Provider value={userInfo}>
			<UpdateUserInfoContext.Provider value={setUserInfo}>{children}</UpdateUserInfoContext.Provider>
		</UserInfoContext.Provider>
	);
}
